import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronLargeLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chevron-large-left, chev left, last"} maskId="square-filled-radius-0-stroke-1-IconChevronLargeLeft"><path fillRule="evenodd" clipRule="evenodd" d="M15.1898 2.34454L9.09144 12.0003L15.1898 21.656L14.3443 22.19L7.90869 12.0003L14.3443 1.81055L15.1898 2.34454Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChevronLargeLeft;
